import { render, staticRenderFns } from "./PostLike.vue?vue&type=template&id=5ac3a73b&scoped=true&"
import script from "./PostLike.vue?vue&type=script&lang=js&"
export * from "./PostLike.vue?vue&type=script&lang=js&"
import style0 from "./PostLike.vue?vue&type=style&index=0&id=5ac3a73b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac3a73b",
  null
  
)

export default component.exports